<template>
  <div id="app">
    <nav class="bg-black c-text-grey-light ">
      <a href=""><img src="@/assets/toyota-lisavarusteet.png" alt="Toyota" class="p-1 py-2"></a>
      <div @click.stop="toggleTab('dealer')" class="cursor--pointer py-1 text-center c-tab" :class="{ 'bg-grey-dark c-tab--active': openTab === 'dealer' }" >
        <i v-if="selectedDealer !== 'none'" class="fa fa-user-circle text-green fa-2x"></i>
        <i v-else class="fa fa-user-circle fa-2x"></i>
      </div>
      <div @click.stop="toggleTab('selected')" class="cursor--pointer py-1 c-tab" :class="{ 'bg-grey-dark c-tab--active': openTab === 'selected' }">
        <i class="fa fa-save fa-2x position-relative" style="left: 18px;"></i>
        <span v-if="selectedAccIDs && selectedAccIDs.length > 0" class="badge badge-pill bg-green position-relative" style="top: -20px; left: 6px;">{{selectedAccIDs.length}}</span>
      </div>
      <div @click.stop="toggleTab('feedback')" class="cursor--pointer py-1 text-center c-tab" :class="{ 'bg-grey-dark c-tab--active': openTab === 'feedback' }" >
        <i class="fa fa-comment fa-2x"></i>
      </div>
      <div @click.stop="toggleTab('videos')" class="cursor--pointer py-1 text-center c-tab" :class="{ 'bg-grey-dark c-tab--active': openTab === 'videos' }" >
        <i class="fa fa-film fa-2x"></i>
      </div>
      <!--
      <div @click.stop="toggleTab('popular')" class="cursor--pointer py-1 text-center c-tab" :class="{ 'bg-grey-dark c-tab--active': openTab === 'popular' }" >
        <i class="fa fa-star fa-2x"></i>
      </div>
      -->
    </nav>

    <aside v-show="openTab" class="c-sidebar bg-grey-dark text-white pr-1 pl-2 shadow">
      <Dealer v-show="openTab === 'dealer'" v-model="selectedDealer" @closeTab="toggleTab('dealer')"></Dealer>
      <Selected v-show="openTab === 'selected'" @AccIDs="updateAccIDs" @closeTab="toggleTab('selected')"></Selected>
      <Feedback v-show="openTab === 'feedback'" @closeTab="toggleTab('feedback')"></Feedback>
      <Videos v-show="openTab === 'videos'" @closeTab="toggleTab('videos')"></Videos>
      <!-- <Popular v-show="openTab === 'popular'" @closeTab="toggleTab('popular')"></Popular> -->
    </aside>

    <div class="main">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Dealer from '@/components/nav/Dealer'
import Selected from '@/components/nav/Selected'
// import Popular from '@/components/nav/Popular'
import Feedback from '@/components/nav/Feedback'
import Videos from '@/components/nav/Videos'

export default {
  name: 'App',

  components: {
    Dealer,
    Selected,
    // Popular,
    Feedback,
    Videos
  },

  data () {
    return {
      openTab: null,
      selectedAccIDs: null
    }
  },

  computed: {
    ...mapGetters({
      selectedDealer: 'getDealer'
    })
  },

  methods: {
    updateAccIDs: function (p) {
      this.selectedAccIDs = p
    },

    toggleTab: function (t) {
      if (this.openTab === t) {
        this.openTab = null
      } else {
        this.openTab = t
      }
    }
  }
}
</script>

<style>
.c-text-grey-light {
  color: #f0f0f0;
}

.c-tab {
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
}

.c-tab--active {
  border-left: 3px solid #4caf50;
}

nav {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 65px;
}
aside {
  position: fixed;
  top: 0;
  left: 65px;
  bottom: 0;
  min-width: 240px;
  max-width: 460px;
  overflow: scroll;
  z-index: 1050;
}

.main {
  margin-left: 65px;
}
</style>
